<div class="p-grid">
    <div class="p-col-12">
        <p-toast></p-toast>
        <div class="card">
            <h5>{{ 'arquivo.titulo' | translate }}</h5>
            <div class="p-fluid p-formgrid p-grid">

                <div class="p-col-12">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-3"
                            *ngIf="(perfil != null && (perfil.nmePerfil === 'ADMTIVIT' || perfil.nmePerfil === 'MNGTIVIT' || perfil.nmePerfil === 'OPRTIVIT')) ">
                            <span class="p-float-label">
                                <h6>{{ 'sacado.cedente' | translate }}</h6>
                                <p-autoComplete [(ngModel)]="cedente" [suggestions]="filteredCedentes"
                                    (completeMethod)="filterCedentes($event)" field="nmeCedente" [dropdown]="true" id="cedente">
                                </p-autoComplete>
                            </span>
                        </div>

                        <div class="p-field p-col-12 p-md-3">
                            <h6>{{ 'arquivo.datainclusaoInicio' | translate }}</h6>
                            <span class="p-float-label">
                                <p-calendar [showIcon]="true" inputId="dtaInicio" [(ngModel)]="filterArquivoHeader.dtaInicio"
                                    [locale]="pt" dateFormat="dd/mm/yy">
                                </p-calendar>
                            </span>
                        </div>

                        <div class="p-field p-col-12 p-md-3">
                            <h6>{{ 'arquivo.datainclusaoFim' | translate }}</h6>
                            <span class="p-float-label">
                                <p-calendar [showIcon]="true" inputId="dtaFim" [(ngModel)]="filterArquivoHeader.dtaFim"
                                    [locale]="pt" dateFormat="dd/mm/yy">
                                </p-calendar>
                            </span>
                        </div>

                        <div class="p-field p-col-12 p-md-3">
                            <h6>{{ 'arquivo.nomeArquivo' | translate }}</h6>
                            <input id="fileName" type="text" pInputText [(ngModel)]="filterArquivoHeader.fileName" />
                        </div>
                    </div>
                </div>
                <div class="p-col-12">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-3">
                            <h6>{{ 'arquivo.nsa' | translate }}</h6>
                            <input id="nsa" type="text" pInputText [(ngModel)]="filterArquivoHeader.nsa" maxlength="16" />
                        </div>

                        <div class="p-field p-col-12 p-md-3">
                            <h6>{{ 'menu.manterBanco' | translate }}</h6>
                            <p-autoComplete [(ngModel)]="bancoSel" [suggestions]="filteredBanco"
                                (completeMethod)="filterBanco($event)" field="nmeBanco" [dropdown]="true" id="codBanco">
                            </p-autoComplete>
                        </div>

                        <div class="p-field p-col-12 p-md-3">
                            <h6>{{ 'arquivo.tpoSentido' | translate }}</h6>
                            <p-autoComplete [(ngModel)]="tpoSentidoSel" [suggestions]="filteredTpoSentido"
                                (completeMethod)="filterTpoSentido($event)" [dropdown]="true" id="tpoSentido">
                            </p-autoComplete>
                        </div>

                        <div class="p-field p-col-12 p-md-3">
                            <h6>{{ 'arquivo.dscStatus' | translate }}</h6>
                            <p-autoComplete [(ngModel)]="dscStatusSel" [suggestions]="filteredDscStatus"
                                (completeMethod)="filterDscStatus($event)" [dropdown]="true" id="dscStatus">
                            </p-autoComplete>
                        </div>
                    </div>
                </div>
            </div>

                <button pButton pRipple type="button" label="{{ 'label.pesquisar' | translate }}" (click)="pesquisarArquivo()" class="p-mr-2"  *ngIf="(perfil != null && (perfil.nmePerfil === 'ADMTIVIT' || perfil.nmePerfil === 'MNGTIVIT' || perfil.nmePerfil === 'OPRTIVIT'))"></button>
                <button pButton pRipple type="button" label="{{ 'label.limparformulario' | translate }}" (click)="limparFormulario()"  class="p-mr-2"  *ngIf="(perfil != null && (perfil.nmePerfil === 'ADMTIVIT' || perfil.nmePerfil === 'MNGTIVIT' || perfil.nmePerfil === 'OPRTIVIT'))"></button>
                <!--<button pButton pRipple type="button" label="{{ 'label.exportar' | translate }}" (click)="downloadFile()" *ngIf="arquivos != null && arquivos.length > 0"></button>-->
                <span *ngIf="arquivos != null && arquivos.length > 0" class="p-mr-2 p-input-icon-left">
                    <p-splitButton   label="Exportar" icon="pi pi-clone"  [model]="exportOptions" styleClass="p-button-info p-mr-2"></p-splitButton>
                </span>

            <p-table #dt [value]="arquivos" dataKey="id"
                     styleClass="p-datatable-customers" [rowHover]="true" [rows]="10" [paginator]="true"
                     [filterDelay]="0" [globalFilterFields]="['codBanco', 'nmeArquivo','nroQtdRegistros','dtaIniciocarga','dtaFimcarga', 'dscStatuscarga']">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <h5>{{ 'arquivo.titulo' | translate }}</h5>
                        <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" [(ngModel)]="busca"/>
                </span>
                    </div>
               </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="nomeEmpresa">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'titulo.cedente' | translate }}
                                <p-sortIcon field="nomeEmpresa"></p-sortIcon>
                                <p-columnFilter type="text" field="nomeEmpresa" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="codBanco">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'banco.codigo' | translate }}
                                <p-sortIcon field="codBanco"></p-sortIcon>
                                <p-columnFilter type="text" field="codBanco" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="nmeArquivo">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'arquivo.nome' | translate }}
                                <p-sortIcon field="nmeArquivo"></p-sortIcon>
                                <p-columnFilter type="text" field="nmeArquivo" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="nroQtdRegistros">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'arquivo.quantidade' | translate }}
                                <p-sortIcon field="nroQtdRegistros"></p-sortIcon>
                                <p-columnFilter type="numeric" field="nroQtdRegistros" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="dtaCriacao">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'arquivo.datainclusao' | translate }}
                                <p-sortIcon field="dtaCriacao"></p-sortIcon>
                                <p-columnFilter type="date" field="dtaCriacao" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="dtaIniciocarga">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'arquivo.iniciocarga' | translate }}
                                <p-sortIcon field="dtaIniciocarga"></p-sortIcon>
                                <p-columnFilter type="date" field="dtaIniciocarga" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="dtaFimcarga">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'arquivo.finalcarga' | translate }}
                                <p-sortIcon field="dtaFimcarga"></p-sortIcon>
                                <p-columnFilter type="date" field="dtaFimcarga" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="dscStatuscarga">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{ 'label.situacao' | translate }}
                                <p-sortIcon field="dscStatuscarga"></p-sortIcon>
                                 <p-columnFilter type="text" field="dscStatuscarga" display="menu" class="p-ml-auto"></p-columnFilter>
                            </div>
                        </th>
                        <th style="width: 8rem"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-arquivo>
                    <tr class="p-selectable-row">
                        <td>
                            <span class="p-column-title">arquivo.nomeEmpresa</span>
                            {{arquivo.nomeEmpresa}}
                        </td>
                        <td>
                            <span class="p-column-title">arquivo.codBanco</span>
                            {{arquivo.codBanco}}
                        </td>
                        <td>
                            <span class="p-column-title">arquivo.nmeArquivo</span>
                            {{arquivo.nmeArquivo}}
                        </td>
                        <td>
                            <span class="p-column-title">arquivo.nroQtdRegistros</span>
                            {{arquivo.nroQtdRegistros}}
                        </td>
                         <td>
                            <span class="p-column-title">arquivo.dtaCriacao</span>
                             {{arquivo.dtaCriacao | date: 'dd/MM/yyyy'}}
                        </td>
                        <td>
                            <span class="p-column-title">arquivo.dtaIniciocarga</span>
                              {{arquivo.dtaIniciocarga | date: 'dd/MM/yyyy HH:mm:ss'}}
                        </td>
                        <td>
                            <span class="p-column-title">arquivo.dtaFimcarga</span>
                            {{arquivo.dtaFimcarga | date: 'dd/MM/yyyy HH:mm:ss'}}
                        </td>
                        <td>
                            <span class="p-column-title">arquivo.dscStatuscarga</span>
                            <span [class]="'customer-badge status-' + arquivo.dscStatuscarga"> {{arquivo.dscStatuscarga}}</span>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{ 'label.totalde' | translate }} {{arquivos ? arquivos.length : 0 }} {{ 'arquivo.arquivos' | translate }}.
                    </div>
                </ng-template>
            </p-table>
                               </div>
                </div>
</div>
